import constantes from '../resources/constantes';
import React, { useState, useContext } from 'react';
import literals from '../resources/literals.json';
/**
 * Contexto utilizado para manejar literales en toda la aplicación
 */

const LanguageContext = React.createContext();
const SetLanguageContext = React.createContext();
const TranslateContext = React.createContext();

function translate(text, language) {
  return literals[language][text];
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(constantes.defaultLanguage);
  const t = text => translate(text, language);
  return (
    <LanguageContext.Provider value={language}>
      <SetLanguageContext.Provider value={setLanguage}>
        <TranslateContext.Provider value={t}>
          {children}
        </TranslateContext.Provider>
      </SetLanguageContext.Provider>
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  return context;
}

export function useSetLanguage() {
  const context = useContext(SetLanguageContext);
  return context;
}

export function useTranslate() {
  const context = useContext(TranslateContext);
  return context;
}
